<template>
  <div>
    <AdminTopBar />
    <slot />
  </div>
</template>

<script>
import AdminTopBar from "./../components/AdminTopBar";

export default {
  name: "Admin",
  components: {
    AdminTopBar
  },
  mounted() {
    this.addAdminClassName();
  },
  methods: {
    addAdminClassName() {
      const body = document.body;
      body.className = "";
      body.classList.add("Admin");
    }
  }
};
</script>

<style>
.Admin {
  background-color: #f8f9fa;
}
</style>
